import React, { useState } from 'react';
import './HelpButton.css';

/**
 * HelpButton - En pedagogisk hjelpeknapp som viser forklarende tekst
 *
 * Props:
 * - title: Overskrift i hjelpevinduet
 * - children: Innholdet som vises (tekst, lister, osv.)
 * - size: 'small' | 'medium' | 'large' (standard: 'medium')
 * - position: 'inline' | 'floating' (standard: 'inline')
 */
function HelpButton({ title, children, size = 'medium', position = 'inline' }) {
  const [visHjelp, setVisHjelp] = useState(false);

  const toggleHjelp = () => {
    setVisHjelp(!visHjelp);
  };

  return (
    <div className={`help-button-container ${position}`}>
      <button
        type="button"
        className={`help-button ${size}`}
        onClick={toggleHjelp}
        title="Klikk for å se hjelpetekst"
      >
        ?
      </button>

      {visHjelp && (
        <div className="help-modal-overlay" onClick={toggleHjelp}>
          <div className="help-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="help-modal-header">
              <h3>{title}</h3>
              <button className="help-modal-close" onClick={toggleHjelp}>
                ✕
              </button>
            </div>
            <div className="help-modal-body">
              {children}
            </div>
            <div className="help-modal-footer">
              <button className="btn-ok" onClick={toggleHjelp}>
                OK, forstått
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default HelpButton;
